var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWhreareyou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "whereAreYouTitle"
  }, "Where Are You") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "whereAreYouTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#F1F5FF",
    cx: 45,
    cy: 45,
    r: 45
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.000000, 26.000000)",
    fill: "#4B7BFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5,0 C30.2695526,0 39,8.73044738 39,19.5 C39,30.2695526 30.2695526,39 19.5,39 L19.0056299,38.9938444 C16.0450088,38.9200501 13.1882991,38.1840843 10.6043541,36.8571323 L10.488,36.795 L3.46444932,37.9859311 L3.2972973,38 C2.02853503,38 1,36.971465 1,35.7027027 L1,35.3819445 L3.947,31.261 L3.87165373,31.1641031 C1.37677548,27.8274339 0,23.7682409 0,19.5 C0,8.73044738 8.73044738,0 19.5,0 Z M19.5,2 C9.83501688,2 2,9.83501688 2,19.5 C2,23.6058859 3.4172519,27.4915019 5.96888568,30.5985529 L6.45554019,31.1911381 L3.084,35.906 L3.111353,35.9346871 C3.14529815,35.9619305 3.1853502,35.9818773 3.22912975,35.9921482 L3.248,35.994 L10.8295846,34.7087273 L11.1338433,34.8746614 C13.6786995,36.2625539 16.5348768,37 19.5,37 C29.1649831,37 37,29.1649831 37,19.5 C37,9.83501688 29.1649831,2 19.5,2 Z M19,27 C19.5522847,27 20,27.4477153 20,28 C20,28.5522847 19.5522847,29 19,29 C18.4477153,29 18,28.5522847 18,28 C18,27.4477153 18.4477153,27 19,27 Z M19,11 C22.2967451,11 24.9998951,13.4967988 24.9998951,16.6326182 C24.9717274,18.5771462 24.1955021,19.5641694 22.205369,20.961659 L21.9241153,21.1565119 C20.2549431,22.3016704 19.789479,22.8525501 19.789479,24 C19.789479,24.5522847 19.3417638,25 18.789479,25 C18.2371943,25 17.789479,24.5522847 17.789479,24 C17.789479,22.1299404 18.5006514,21.1497403 20.3315445,19.83096 L20.8292367,19.4822343 C22.5043293,18.3329974 22.9832181,17.7694123 23,16.6181341 C23,14.6384194 21.2261024,13 19,13 C16.7738976,13 15,14.6384194 15,16.6181341 C15,17.1704189 14.5522847,17.6181341 14,17.6181341 C13.4477153,17.6181341 13,17.1704189 13,16.6181341 C13,13.4967988 15.7032549,11 19,11 Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhreareyou);
export default __webpack_public_path__ + "static/media/icon-whreareyou.d55262a1737703a486fb164c2af6c4fa.svg";
export { ForwardRef as ReactComponent };